import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { CustomThemeProvider } from '../src/Layout/ThemeContext';
import router from './Routes';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faImage as farImage } from '@fortawesome/free-regular-svg-icons';
import { faVideo as fasVideo } from '@fortawesome/free-solid-svg-icons';

library.add(farImage, fasVideo);

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  const [isDevToolsOpen, setIsDevToolsOpen] = useState(false);

  const detectDevTools = () => {
    const threshold = 160; 
    const width = window.innerWidth;
    const height = window.innerHeight;
    const devToolsOpened =
      width - window.outerWidth > threshold || height - window.outerHeight > threshold;
    setIsDevToolsOpen(devToolsOpened);
  };

  useEffect(() => {
    const preventRightClick = (e: MouseEvent) => {
      e.preventDefault();
    };

    const preventDevTools = (e: KeyboardEvent) => {
      if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I')) {
        e.preventDefault();
      }
    };

    window.addEventListener('contextmenu', preventRightClick);

    window.addEventListener('keydown', preventDevTools);

    const devToolsInterval = setInterval(detectDevTools, 1000);

    return () => {
      window.removeEventListener('contextmenu', preventRightClick);
      window.removeEventListener('keydown', preventDevTools);
      clearInterval(devToolsInterval);
    };
  }, []);

  return (
    <CustomThemeProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        {isDevToolsOpen && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              color: '#fff',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '24px',
              zIndex: 9999,
              pointerEvents: 'none', // Prevent interaction with the overlay
            }}
          >
            Developer Tools Detected! Please close them to interact with the page.
          </div>
        )}
      </QueryClientProvider>
    </CustomThemeProvider>
  );
}

export default App;
